<template>
  <v-container fluid class="px-4 py-5 text-center">
    <!-- SNACKBAR -->
    <v-snackbar
      v-model="snackState"
      :color="snackColor"
      :timeout="snackTime"
      bottom
      right
    >
      {{ snackText }}
    </v-snackbar>

    <!-- Dialog: CONFIRMAR ACCION -->
    <v-dialog v-model="dialog" max-width="350">
      <v-card class="py-3">
        <v-card-title class="headline">
          ¿Desea "{{ textGuardarTurno }}"?
        </v-card-title>
        <v-card-text class="subtitle-1">
          Confirmar esta acción es para
          <span class="font-weight-medium">"{{ textGuardarTurno }}"</span>, con
          la grúa
          <span class="font-weight-medium"> {{ getNombreGrua }}.</span>
        </v-card-text>
        <v-card-actions class="px-6">
          <v-btn color="primary" outlined @click="dialog = false">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="guardarTurno"> Aceptar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout column>
      <v-layout>
        <v-flex xs12>
          <h1>{{ mensajeBienvenida }}</h1>
        </v-flex>
      </v-layout>

      <v-layout class="mt-4">
        <v-flex xs12>
          <h2>¿Qué grúa utilizaremos hoy?</h2>
        </v-flex>
      </v-layout>

      <v-layout class="text-center mt-8">
        <v-spacer></v-spacer>
        <v-flex xs12 sm6 md4>
          <v-autocomplete
            v-model="gruaDisponibleId"
            :loading="loadGruasDisponibles"
            :items="gruasDisponibles"
            item-value="proveedorId"
            item-text="nombre"
            label="Seleccionar Grúa"
            @click="verificarGruasDisponibles"
            clearable
            :disabled="turnoActivo"
            dense
          ></v-autocomplete>
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>

      <v-layout>
        <v-spacer></v-spacer>
        <v-flex xs12 sm6 md4 text-center>
          <v-btn
            color="primary"
            :disabled="gruaDisponibleId == null"
            width="100%"
            @click="dialog = true"
            >{{ textGuardarTurno }}</v-btn
          >
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      snackState: false,
      snackColor: "primary",
      snackText: "",
      snackTime: 3500,
      gruaDisponibleId: null,
      gruasDisponibles: [],
      nombreGrua: "",
      loadGruasDisponibles: false,
      turno: {},
      turnoActivo: false,
      dialog: false,
    };
  },
  created() {
    if (this.$store.state.usuario) {
      if (this.$store.state.usuario.rol != "Operador Grua") {
        this.$router.push({ name: "novedades" });
      } else {
        this.verificarTurno();
      }
    } else {
      this.$router.push({ name: "login" });
    }
  },
  computed: {
    mensajeBienvenida() {
      return (
        `Bienvenido/a, ${this.$store.state.usuario.nombre}!` || `Bienvenido/a!`
      );
    },
    textGuardarTurno() {
      return this.turnoActivo ? "Finalizar Turno" : "Iniciar Turno";
    },
    getNombreGrua() {
      if (!this.gruaDisponibleId) return "";

      return this.gruasDisponibles.filter(
        (g) => g.proveedorId == this.gruaDisponibleId
      )[0].nombre;
    },
  },
  methods: {
    verificarTurno() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(
          `api/HistorialOperadoresGrua/VerificarTurno/${this.$store.state.usuario.idUsuario}`,
          configuracion
        )
        .then((res) => {
          this.turno = res.data;

          this.turnoActivo = this.turno.historialOperadoresGruaId
            ? true
            : false;

          if (this.turnoActivo) {
            this.gruasDisponibles.push({
              proveedorId: res.data.proveedorId,
              nombre: res.data.proveedor.nombre,
            });

            this.gruaDisponibleId = res.data.proveedorId;
          } else {
            this.verificarGruasDisponibles();
          }
        })
        .catch((err) => console.error(err));
    },
    verificarGruasDisponibles() {
      this.loadGruasDisponibles = true;
      this.gruaDisponibleId = null;

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/HistorialOperadoresGrua/GruasDisponibles", configuracion)
        .then((res) => {
          this.gruasDisponibles = res.data;
        })
        .catch((err) => console.error(err))
        .finally(() => {
          this.loadGruasDisponibles = false;
        });
    },
    guardarTurno() {
      if (this.turnoActivo) {
        this.cerrarTurno();
      } else {
        this.iniciarTurno();
      }
      this.dialog = false;
    },
    iniciarTurno() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .post(
          "api/HistorialOperadoresGrua",
          {
            proveedorId: this.gruaDisponibleId,
            usuarioId: this.$store.state.usuario.idUsuario,
          },
          configuracion
        )
        .then((res) => {
          this.snackState = true;
          this.snackText = "¡Grúa seleccionada con éxito!";
          this.snackColor = "green";
          this.verificarTurno();
        })
        .catch((err) => {
          this.snackState = true;
          this.snackText = `Lo sentimos, la grúa ${this.getNombreGrua} ya fue seleccionada. Intente nuevamente.`;
          this.snackColor = "red";
          this.snackTime = 4000;

          this.verificarGruasDisponibles();
          console.error(err);
        });
    },
    cerrarTurno() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .put(
          `api/HistorialOperadoresGrua/${this.$store.state.usuario.idUsuario}`,
          null,
          configuracion
        )
        .then((res) => {
          this.snackState = true;
          this.snackText = "¡Turno Finalizado con éxito!";
          this.snackColor = "green";

          this.verificarTurno();
          this.gruaDisponibleId = null;
        })
        .catch((err) => {
          if (err.response.status == 404) {
            this.verificarTurno();
          }
          console.error(err);
        });
    },
  },
};
</script>
